<template>
  <div id="app" :data-theme="theme">
    <Layout v-if="layout && render && getLoginstatus == Enums.LoadingStatusType.Success" />
    <router-view v-if="!layout && render" />
    <Noti v-if="render" />
    <portal-target name="contextMenu" />
  </div>
</template>
<script>
import {
  BroadcastTabChannelMasterTabClose,
  CheckBroadcastIsSupport,
  SetTabChannel,
} from "./broadcastChannel/tabChannel";
import Enums from "./enums/enums";
import { ClearOptionsExportFromCookie } from "./helper/exportHelper";
import { SocketConnect, SocketDisconnect } from "./helper/notificationHelper";
import {
  ClearMasterTabFromCookies,
  ClearTabFromSessionStorage,
  GetTabIdFromSessionStorage,
  IsMasterTab,
  IsMasterTabAvailable,
  RemoveTabDB,
} from "./helper/tabHelper";
import { ClearAccountFromIndexedDB } from "./IndexedDB/CacheIndexedDB";
import { CheckIndexedDBIsSupport } from "./IndexedDB/tabIndexedDB";
export default {
  components: {
    Layout: () => import("./Layout"),
  },
  created() {
    ClearOptionsExportFromCookie();
    SetTabChannel();
  },
  mounted() {
    if (localStorage.lang != null) this.$i18n.locale = localStorage.lang;
    window.addEventListener("focus", () => {
      if (this.getLoginstatus == Enums.LoadingStatusType.Success && !IsMasterTabAvailable()) {
        SocketConnect();
      }
    });
    window.addEventListener("beforeunload", async () => {
      SocketDisconnect();
      if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
        let tabId = GetTabIdFromSessionStorage();
        let isMasterTab = IsMasterTab();
        if (isMasterTab) {
          ClearMasterTabFromCookies();
          BroadcastTabChannelMasterTabClose();
        }
        if (tabId) {
          ClearTabFromSessionStorage();
          await RemoveTabDB(tabId);
        }
      }
    });
  },
  destroyed() {
    localStorage.removeItem("lang");
  },
  computed: {
    theme() {},
    localeLanguage() {
      return this.$i18n.locale;
    },
    getLoginstatus() {
      return this.$store.getters.GetLoginstatus;
    },
  },
  data() {
    return {
      layout: false,
      test: process.env.VUE_APP_Title,
      render: true,
    };
  },
  watch: {
    $route(newValue, oldValue) {
      this.setWebTitle(this.$t(newValue.meta.title));
      this.checkLayout(newValue.matched[0].name);
    },
    "$i18n.locale": {
      async handler(newValue, oldValue) {
        localStorage.setItem("lang", newValue);
        this.setWebTitle(this.$t(this.$route.meta.title));
        await ClearAccountFromIndexedDB();
        this.render = false;
        this.$nextTick(() => {
          this.render = true;
        });
      },
    },
  },
  methods: {
    setWebTitle(title) {
      if (title) {
        document.title = title;
      }
    },
    checkLayout(name) {
      if (
        name !== "login" &&
        name !== "logout" &&
        name !== "end" &&
        name !== "from_register" &&
        name !== "register" &&
        name !== "sme_register" &&
        name !== "accountingfirm_register" &&
        name !== "selectlist" &&
        name !== "emailVerification" &&
        name !== "createOrganization" &&
        name !== "createOrganizationDemo" &&
        name !== "forgotPwd" &&
        name !== "resetPwd" &&
        name !== "pageNotFound" &&
        name !== "sessionExpire" &&
        name !== "tooManyRequest" &&
        name !== "canNotAccessMerchant" &&
        name !== "update" &&
        name !== "welcome" &&
        name !== "acceptInvitation" &&
        name !== "accepInvitationFailPage" &&
        name !== "selectApplication" &&
        name !== "registerV2" &&
        name !== "entrepreneur_register" &&
        name !== "accountant_register" &&
        name !== "register_partner" &&
        name !== "accountant_register_partner" &&
        name !== "entrepreneur_register_partner" &&
        name !== "trial_function_salesdocuments" &&
        name !== "trial_function_payroll" &&
        name !== "trial_function_tax" &&
        name !== "trial-function-accounting-payroll" &&
        name !== "download_peak_mobile"
      ) {
        this.layout = true;
      } else {
        this.layout = false;
      }
    },
  },
};
</script>
<style lang="scss">
@import url("./assets/plugin/Bootstap/css/bootstrap.min.css");
@import url("./assets/iconFont/css/PEAK-Icon-Pack.css");
@import url("./assets/css/animate.min.css");

@font-face {
  font-family: "Maibork-lig";
  src: url("./assets/font/sukhumvittadmai/sukhumvittadmai_lig.woff") format("woff");
  font-display: swap;
}

@font-face {
  font-family: "Maibork-bold";
  src: url("./assets/font/sukhumvittadmai_bold/sukhumvittadmai_sebold.woff") format("woff");
  font-display: swap;
}

@font-face {
  font-family: "micrenc";
  src: url("./assets/font/micrenc/micrenc.woff") format("woff");
  font-display: swap;
}

@font-face {
  font-family: "THSarabunNew";
  src: url("./assets/font/thSarabunNew/THSarabunNew.woff") format("woff");
  font-display: auto;
}

.master {
  background-image: url("./assets/img/PeakExperienceBackground.jpg");
  @include master;

  .box {
    @include box;
  }
}
</style>
